import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const qstHttp = axios.create({ baseURL: `${API}/qst` });

export const qstTrades          = () => qstHttp.get("/trades").then(r => r.data);
export const qstTradeDetail     = (slug) => qstHttp.get(`/trades/${slug}`).then(r => r.data);
export const qstLessons         = (params = {}) => qstHttp.get("/lessons", { params }).then(r => r.data);
export const qstLessonDetail    = (slug) => qstHttp.get(`/lessons/${slug}`).then(r => r.data);
export const qstPlans           = () => qstHttp.get("/plans").then(r => r.data);
export const qstStats           = () => qstHttp.get("/stats").then(r => r.data);
export const qstAssistantAsk    = (payload) => qstHttp.post("/assistant/ask", payload).then(r => r.data);
export const qstCalcRework      = (payload) => qstHttp.post("/calc/rework", payload).then(r => r.data);
export const qstCalcInjury      = (payload) => qstHttp.post("/calc/injury", payload).then(r => r.data);
export const qstContact         = (payload) => qstHttp.post("/contact", payload).then(r => r.data);
export const qstStorySubmit     = (payload) => qstHttp.post("/story/submit", payload).then(r => r.data);

export const qstLanguages       = () => qstHttp.get("/languages").then(r => r.data);
export const qstTranslation     = (slug, lang) => qstHttp.get(`/lessons/${slug}/translation`, { params: { lang } }).then(r => r.data);
export const qstTranslations    = (slug) => qstHttp.get(`/lessons/${slug}/translations`).then(r => r.data);
export const qstDashboardContractor = () => qstHttp.get("/dashboard/contractor").then(r => r.data);
export const qstAcknowledge     = (assignment_id, worker_name) => qstHttp.post("/dashboard/contractor/acknowledge", { assignment_id, worker_name }).then(r => r.data);
export const qstCheckout        = (plan_key) => qstHttp.post(`/checkout?plan_key=${plan_key}`).then(r => r.data);
